export const getLastSentThirdPartySubject = () => {
  try {
    return window.parent.hsCalling && window.parent.hsCalling.lastSentThirdPartySubject;
  } catch (e) {
    return undefined;
  }
};
export const onCallSavedThirdParty = ({
  engagementId
}) => {
  try {
    if (window.parent.hsCalling && window.parent.hsCalling.onCallSavedThirdParty) {
      window.parent.hsCalling.onCallSavedThirdParty({
        engagementId
      });
    }
  } catch (e) {
    // do nothing
  }
};